module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images-old/leah-darby-eddf869787b10c5b80e0d8c39de74a64.jpg";